<template>
  <ul>
    <li>
      <details :open="!startCollapsed" @click="(e) => !collapsable && e.preventDefault()">
        <slot name="node" :node="rootNode"></slot>

        <InfuseTree
          v-for="childNode in rootNode.children"
          :key="childNode.key"
          :root-node="childNode"
          :collapsable="collapsable"
          :start-collapsed="startCollapsed"
          :is-first-recursion="false"
        >
          <template #node="{ node }">
            <slot name="node" :node="node" :parent-node="rootNode"></slot>
          </template>
          <template #leaf="{ leaf }">
            <slot name="leaf" :leaf="leaf"></slot>
          </template>
        </InfuseTree>

        <ul>
          <li v-for="leaf in rootNode.leafs" :key="leaf.key">
            <slot name="leaf" :leaf="leaf"></slot>
          </li>
        </ul>
      </details>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { UiTreeNode } from '@infuse/ui/domain';
import { InfuseTree } from '../index';

interface Props {
  collapsable?: boolean;
  startCollapsed?: boolean;
  rootNode: UiTreeNode<any, any>;
  isFirstRecursion?: boolean;
}

withDefaults(defineProps<Props>(), {
  collapsable: true,
  startCollapsed: false,
  isFirstRecursion: true
});
</script>
